/* @ngInject */
const railwayIcons = () => {
  const self = {}
  self.number = 'assignment'
  self.length = 'straighten'
  self.left = 'skip_previous'
  self.right = 'skip_next'

  return self
}

export default railwayIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/resources/icons.resource.js